import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Toast } from '../../../models';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss'],
  host: { 'class': 'toast-container position-fixed top-0 end-0 p-3', 'style': 'z-index: 1200' }
})
export class ToastsComponent {
  @Input() toasts: Toast[] = [];
  @Input() delay = 5000;

  @Output() removeToast = new EventEmitter<Toast>();
}
